<template>
  <div class="meeting">
    <common-layout>
      <div slot="header">
        <div class="tabs">
          <span
            v-for="btn in tabs"
            :key="btn.id"
            @click="handleClick(btn.id)"
            :class="{ active_t: activeTab == btn.id }"
            >{{ btn.name }}</span
          >
        </div>
      </div>
      <div slot="container">
        <component
          v-for="(item, index) in apps"
          :is="item.app"
          v-if="index + 1 == activeTab"
          :key="index"
        ></component>
      </div>
    </common-layout>
  </div>
</template>
<script>
import CommonLayout from "../../components/common-layout.vue";
export default {
  components: { CommonLayout },
  name: "index",
  data() {
    return {
      tabs: [
        {
          id: 1,
          name: "会议",
        },
        {
          id: 2,
          name: "签到名单",
        },
      ],
      activeTab: 1,
      apps: [],
      comps: [{ name: "meeting" }, { name: "sign" }],
    };
  },
  created() {
    this.comps.forEach((app) => {
      this.apps.push({
        app: require(`./components/${app.name}.vue`).default,
        url: app.url,
      });
    });
  },
  methods: {
    // 切换tab
    handleClick(val) {
      this.activeTab = val;
      localStorage.setItem("tab", val);
    },
  },
};
</script>
<style lang="scss" scoped>
@include component(meeting) {
  width: 100%;
  height: 100%;
  .tabs {
    width: 300px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }
}
</style>
